export const FREE_LIMIT_FIELDS = [
  ['daily_trial_limit', 'Movimientos diarios', 5],
  ['weekly_free_limit', 'Movimientos semanales', 20],
  ['weekly_audio_limit', 'Audios semanales', 5],
  ['weekly_photo_limit', 'Fotos semanales', 5],
  ['free_subscription_limit', 'Suscripciones financieras', 3],
  ['free_account_limit', 'Cuentas y billeteras activas', 3],
  ['free_card_limit', 'Tarjetas', 2],
  ['free_trip_limit', 'Viajes activos', 2],
  ['free_asset_limit', 'Activos registrados', 3],
];
export const FREE_DEFAULTS = Object.fromEntries(FREE_LIMIT_FIELDS.map(([field, , value]) => [field, value]));
export const QUOTA_LABELS = {
  movements_daily: 'Movimientos hoy', movements_weekly: 'Movimientos esta semana',
  audio: 'Audios esta semana', photo: 'Fotos esta semana', subscriptions: 'Suscripciones',
  accounts: 'Cuentas y billeteras', cards: 'Tarjetas', trips: 'Viajes activos', assets: 'Activos',
};

export function accessStatus(user, now = Date.now()) {
  const access = user?.access_policy;
  if (user?.role === 'admin') return { active: true, isExpired: false, daysLeft: null, label: 'Administrador' };
  if (!access) return { active: true, isExpired: false, daysLeft: null, label: 'Plan Gratis' };
  const paidActive = access.is_paid && (!access.paid_ends_at || new Date(access.paid_ends_at).getTime() > now);
  const end = paidActive ? access.paid_ends_at : access.free_ends_at;
  const daysLeft = end ? Math.max(0, Math.ceil((new Date(end).getTime() - now) / 86400000)) : null;
  const active = access.active && (end ? daysLeft > 0 : true);
  return { active, isExpired: !active, daysLeft,
    label: paidActive ? 'Suscripción activa' : active ? 'Plan Gratis' : 'Acceso gratuito vencido' };
}
